var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('b-container', [_vm.$options.components['advertisement-loading'] ? [_vm.isLoading ? _c('advertisement-loading') : _vm._e()] : _vm._e(), !_vm.isLoading ? _c('div', [_c('b-row', [_c('b-col', {
    staticClass: "my-4"
  }, [_c('div', {
    staticClass: "main-banner"
  }, [_c('img', {
    attrs: {
      "src": _vm.marketBannerImage.icon && _vm.marketBannerImage.icon.fileUrl || '',
      "alt": "Healthcare Market Banner"
    }
  })])])], 1), _c('b-row', [_vm._l(_vm.productList, function (product) {
    return _c('b-col', {
      key: product.category,
      attrs: {
        "md": "4"
      }
    }, [_c('div', [_c('b-card', {
      staticClass: "mb-2",
      attrs: {
        "title": product.hospitalName,
        "img-src": product.backgroundImage,
        "img-alt": "Image",
        "img-top": "",
        "tag": "article"
      }
    }, [_c('b-card-text', {
      staticClass: "mb-1"
    }, [_c('b-icon', {
      staticClass: "mr-1",
      attrs: {
        "icon": "geo-alt-fill"
      }
    }), _vm._v("Haldwani, Uttarakhand ")], 1), _c('div', {
      staticClass: "d-flex justify-content-between align-items-center"
    }, [_c('div', [_c('span', [_c('b-icon', {
      staticClass: "custom-icon",
      attrs: {
        "icon": "geo-alt-fill"
      }
    }), _c('b-icon', {
      staticClass: "custom-icon",
      attrs: {
        "icon": "geo-alt-fill"
      }
    }), _c('small', {
      staticClass: "ml-1"
    }, [_vm._v("5 KM")])], 1)]), _c('div', [[_c('div', [_c('b-form-rating', {
      staticClass: "review-star",
      attrs: {
        "readonly": "",
        "variant": "warning",
        "inline": "",
        "no-border": ""
      },
      model: {
        value: _vm.starValue,
        callback: function ($$v) {
          _vm.starValue = $$v;
        },
        expression: "starValue"
      }
    })], 1)]], 2)]), _c('div', {
      staticClass: "d-flex justify-content-center mt-1"
    }, [_c('b-button', {
      staticClass: "custom-button",
      attrs: {
        "variant": "custom"
      },
      on: {
        "click": _vm.onClickBooking
      }
    }, [_vm._v("Direct Booking ")])], 1)], 1)], 1)]);
  }), _c('div', [_c('b-container', [_vm.$options.components['advertisement-bottom-banner'] ? [_c('advertisement-bottom-banner')] : _vm._e()], 2)], 1)], 2)], 1) : _vm._e()], 2);

}
var staticRenderFns = []

export { render, staticRenderFns }